import { useMutation } from 'react-query';

import { billingErrorToast } from '@components/BillingError/toast';
import { CreateSubscriptionParams, createSubscription } from '@utils/backend-api/stripe';
import { BillingErrorPayload, normalizeBillingError } from '@utils/billingErrors';

export default function useCreateSubscription() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (params: CreateSubscriptionParams) => createSubscription(params),
    {
      onError: (
        error: Partial<BillingErrorPayload> & { message?: string; redirect_to?: string }
      ) => {
        billingErrorToast(
          normalizeBillingError(
            error,
            'Something went wrong. Please refresh this page or try again later.'
          )
        );
        if (error.redirect_to) {
          setTimeout(() => (window.location.href = error.redirect_to), 5000);
        }
      },
    }
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
